export default __webpack_public_path__ + "static/media/youtube.35205f8b.svg";